import { Leaf, Mail, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1E3F20] text-[#E2EBE1] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src="/foodbone-logo.png" alt="FoodBone" className="h-10 w-10 object-contain bg-white/90 rounded-lg p-1" />
            <span className="font-display text-xl font-bold text-white">Food&amp;Bone</span>
          </div>
          <p className="text-sm text-[#B9C9B7] leading-relaxed max-w-xs">
            Wissenschaftlich fundierte Ernährung für starke Knochen – mit Fokus auf Probiotika und Naturprodukte.
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">Themen</h4>
          <ul className="space-y-2 text-sm text-[#B9C9B7]">
            <li>Mythen &amp; Fakten</li>
            <li>Probiotika &amp; Gut-Bone-Axis</li>
            <li>Wissenschaft &amp; Studien</li>
            <li>Rezepte &amp; Ernährungspläne (Premium)</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">Kontakt</h4>
          <a href="mailto:foodbone@gmx.de" className="inline-flex items-center gap-2 text-sm text-[#B9C9B7] hover:text-white transition-colors">
            <Mail className="w-4 h-4" /> foodbone@gmx.de
          </a>
          <h4 className="font-semibold text-white mt-6 mb-3">Partnerseite</h4>
          <a href="https://laclive.de" target="_blank" rel="noopener noreferrer" data-testid="footer-laclive-link" className="inline-flex items-center gap-2 text-sm text-[#B9C9B7] hover:text-white transition-colors">
            <ExternalLink className="w-4 h-4" /> LacLive – Laktoseintoleranz
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#8FA58C]">
          <p className="flex items-center gap-1.5"><Leaf className="w-3.5 h-3.5" /> © {new Date().getFullYear()} FoodBone. Alle Rechte vorbehalten.</p>
          <p>Kein Ersatz für ärztliche Beratung. Bei Beschwerden bitte medizinischen Rat einholen.</p>
        </div>
      </div>
    </footer>
  );
}
